export enum EClaimDetailsTab {
  OVERVIEW = "overview",
  PROCESS = "process",
  INVESTIGATION = "investigation",
  DECISION = "decision",
  FINANCIALS = "financials",
  DOCUMENTS = "documents",
  PARTIES = "parties",
  LEGAL = "legal",
}
